import injectionCode from '../../../preview/standard-checkout'

const type = 'standard'
const path = '/standard/html-node/'
const name = 'index.html'

export { type, path, name, injectionCode }
